import { ChangeEvent, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const PictureWrapper = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  position: relative;
  background-color: gray;
`;

const Picture = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: gray;
`;

const Input = styled.input`
  display: none;
`;

const Label = styled.label`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  opacity: 0.2;
  background-color: #b1b1b1;
  :hover {
    border: 3px solid gray;
    opacity: 0.4;
  }
`;

const EditButton = styled.button`
  border: none;
  outline: none;
  background: none;
  font-size: 1rem;
  margin-top: 8px;
  padding: 5px 7px;
  cursor: pointer;
`;

const ProfilePicture = () => {
  const { t } = useTranslation("common");
  const [picture, setPicture] = useState<string>();
  const [editable, setEditable] = useState<boolean>(false);

  const onImageChange = (e: ChangeEvent) => {
    const input = e.target as HTMLInputElement;
    if (!input.files?.length) return;
    const img = input.files[0];
    setPicture(URL.createObjectURL(img));
  };

  return (
    <Wrapper>
      <PictureWrapper>
        <Picture />
        {editable ? (
          <Label>
            <Input type="file" onChange={onImageChange} />
          </Label>
        ) : null}
      </PictureWrapper>
      <EditButton onClick={() => setEditable((value) => !value)}>
        {editable ? t("forms:save") : t("edit")}
      </EditButton>
    </Wrapper>
  );
};

export default ProfilePicture;
